import { render, staticRenderFns } from "./CommentScreenPlayer.vue?vue&type=template&id=79084824&scoped=true"
import script from "./CommentScreenPlayer.vue?vue&type=script&lang=ts"
export * from "./CommentScreenPlayer.vue?vue&type=script&lang=ts"
import style0 from "./CommentScreenPlayer.vue?vue&type=style&index=0&id=79084824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79084824",
  null
  
)

export default component.exports